import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import Lightbox from 'components/Lightbox';
import Photographer from 'components/Photographer';
import { breakpoints } from 'js/breakpoints';
import './ImageWithPopup.scss';
import cn from 'classnames';

const ImageWithPopup = ({ image, photographer, className }) => {
  return (
    <div className={cn('image-with-popup', className)}>
      <Lightbox>
        <div className="image-with-popup__holder">
          <ResponsiveImage
            {...image}
            loading="lazy"
            className="responsive-image_size_image-with-popup"
            sources={[
              {
                width: 430,
                height: 226,
                media: breakpoints.xs,
              },
              {
                width: 767,
                height: 403,
                media: breakpoints.s,
              },
              {
                width: 920,
                height: 483,
                media: breakpoints.m,
              },
              {
                width: 1870,
                height: 982,
                media: breakpoints.l,
              },
            ]}
          />
        </div>
      </Lightbox>
      {photographer && (
        <Photographer
          className="photographer_in-image-with-popup"
          {...photographer}
        />
      )}
    </div>
  );
};

ImageWithPopup.propTypes = {
  image: PropTypes.exact(ResponsiveImage.propTypes),
  photographer: PropTypes.exact(Photographer.propTypes),
  className: PropTypes.string,
};

export default ImageWithPopup;
